import React from 'react';
import moment from 'moment';
import { T } from '@testout/labsim-ui-atomics';
import styles from './ProductVersionSelectorControl.module.less';
const ProductVersionSelectorControl = ({ currentProduct, versionFixed, availableVersions, onChange, }) => {
    const render = () => {
        let versions = [];
        if (availableVersions != null) {
            versions = availableVersions.map((version) => {
                const isCurrentVersion = (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productVersionId) === version.productVersionId;
                return (React.createElement(T.Dropdown.Item.Button, { key: version.version, automationId: 'versionBtn', onClick: () => onChange(version.productVersionId) },
                    React.createElement("div", { className: styles.versionBtn },
                        React.createElement(T.Text.P, { automationId: 'versionText', variation: T.Text.Variation.Small },
                            "Version:",
                            ' ',
                            React.createElement(T.Text.Span, { automationId: `version_${version.version}`, variation: T.Text.Variation.Inherit }, version.version),
                            isCurrentVersion && (React.createElement(T.Icon, { className: styles.selected, automationId: 'selected', variation: T.IconVariation.Check }))),
                        React.createElement(T.Text.P, { automationId: 'versionLangDate', variation: T.Text.Variation.Smallest },
                            version.language + ` `,
                            "Released: ",
                            moment(version.releaseDate).format('MMMM YYYY')))));
            });
        }
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", null, (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.hasOtherVersions) && !versionFixed && versions.length > 1 && (React.createElement(T.Dropdown, { automationId: 'versionSelect' },
                React.createElement(T.Dropdown.Toggle.Button, { variation: T.ButtonVariation.PrimaryText }, "Select Version"),
                React.createElement(T.Dropdown.Menu, null, versions))))));
    };
    return render();
};
export default ProductVersionSelectorControl;
//# sourceMappingURL=ProductVersionSelectorControl.js.map